import * as actionTypes from "../actionTypes";

let orderActionCreators = (data, actionType) => {
  return {
    type: actionTypes[actionType],
    payload: data,
  };
};

export const findActiveOrders = (orders) => {
  return orderActionCreators(orders, "ACTIVE_ORDERS");
};
export const findReadyToSendOrders = (orders) => {
  return orderActionCreators(orders, "READY_TO_SEND");
};

export const findOrdersHistory = (orders) => {
  return orderActionCreators(orders, "ORDERS_HISTORY");
};

export const getSubOrders = (orders) => {
  return orderActionCreators(orders, "SUB_ORDERS");
};

export const popupMessagesHandler = (messageObject) => {
  return orderActionCreators(messageObject, "MESSAGES");
};

export const setQrCode = (code) => {
  return orderActionCreators(code, "QRCODE");
};
export const setLoading = (mode) => {
  return orderActionCreators(mode, "LOADING");
};
export const setLoading_MODAL = (mode) => {
  return orderActionCreators(mode, "MODAL_LOADING");
};
export const setRegisterStart = (mode) => {
  return orderActionCreators(mode, "REGISTER_INITIATED");
};

export const set_Refresh = (data) => {
  return orderActionCreators(data, "REFRESH");
};
export const set_Let_Refresh = (mode) => {
  return orderActionCreators(mode, "LET_REFRESH");
};

export const set_Qr_Loading = (data) => {
  return orderActionCreators(data, "QR_LOAD");
};
export const set_Load_Download = (data) => {
  return orderActionCreators(data, "LOAD_DOWNLOAD");
};
export const set_Message = (data) => {
  return orderActionCreators(data, "MESSAGE");
};
export const set_Current_Order = (data) => {
  return orderActionCreators(data, "CURRENT_ORDER");
};
export const set_active_ready_orders_Length = (data) => {
  return orderActionCreators(data, "SET_ORDERS_LENGTH");
};
